var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChatTeardropDots = function SvgIconChatTeardropDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.983 6.233a7.625 7.625 0 1 1 5.392 13.017H4.75v-7.625c0-2.022.803-3.962 2.233-5.392M4.477 21.25h7.898a9.625 9.625 0 1 0-9.625-9.625v7.898a1.713 1.713 0 0 0 1.727 1.727M13.875 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m3 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-7.5-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconChatTeardropDots;